import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { AuthLayout } from '../../components/AuthLayout';
import { ROUTES } from '../../constants/routes';
import { LoginPage, RegistrationPage, EnterEmailPage, ConfirmPassPage } from '../../features/auth';

export const Auth = () => (
  <AuthLayout>
    <Switch>
      <Route path={ROUTES.LOGIN} exact={true} component={LoginPage} />
    </Switch>
    <Switch>
      <Route path={ROUTES.REGISTRATION} component={RegistrationPage} />
    </Switch>
    <Switch>
      <Route path={ROUTES.RECOVER_PASSWORD_EMAIL} component={EnterEmailPage} />
    </Switch>
    <Switch>
      <Route path={ROUTES.RECOVER_PASSWORD_CONFIRM} component={ConfirmPassPage} />
    </Switch>
  </AuthLayout>
);
